
let $TRIGGER;


function getReviewEmded(fullReview) {
  return `
    <div class="ps-modal__frame">
      ${fullReview.innerHTML}
    </div>`;
}

function getOverlayHtml(inner) {
  const doc = document;
  const body = doc.body;
  const html = `<div class="ps-overlay__inner">${inner}</div>`;

  // create the child node
  const div = doc.createElement('div');
  div.innerHTML = html;
  div.className = 'ps-overlay';

  // augment the DOM
  body.appendChild(div);

  // return the destroy method
  return () => {
    body.removeChild(div);
  };
}

function getFullReview(e) {
  const parent = e.target.parentNode;
  return parent.parentNode.querySelector('.ps-modal');
}

function toggleAttribute(e) {
  e.preventDefault();
  e.stopImmediatePropagation();

  const self = e.target;
  const className = self.className;
 
  if (!/poster$/i.test(className)) return;
  
  const fullReview = getFullReview(e);
  const iframe = getReviewEmded(fullReview);
  const destroy = getOverlayHtml(iframe);

  // bind an event to close the ovelay
  document.querySelector('.ps-overlay').addEventListener('click', destroy);
}

export default class Modal {
  constructor($el, opts) {
    $TRIGGER = $el;
  }

  init() {
    $TRIGGER.addEventListener('click', toggleAttribute);
  }
}



// WEBPACK FOOTER //
// ./js/modules/Modal.js